import { Navigate } from 'react-router-dom';
import { useAuth } from './AuthContext';
import DnaLoader from '../components/Loading/DnaLoader';

export default function RequireAuth({ children }) {
  const { status, isAuthenticated } = useAuth();

  if (status === 'loading') {
    return (
      <div className="main-panel">
        <DnaLoader visible height="50" width="50" ariaLabel="dna-loading" />
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  return children;
}
